'use client';

interface HeaderSubscribeButtonProps {
  openNewsletterModal: () => void;
}

export default function HeaderSubscribeButton({ openNewsletterModal }: HeaderSubscribeButtonProps) {

  return (
    <div className="subscribe-button-wrapper">
      {/* Desktop Subscribe Button */}
      <button
        onClick={openNewsletterModal}
        className="hidden md:flex btn-premium bg-[#e7131a] h-10 px-5 md:px-6 py-2.5 font-ibm-plex-sans-condensed font-medium text-[12px] md:text-[13px] lg:text-[14px] text-white text-center tracking-[1.2px] md:tracking-[1.3px] lg:tracking-[1.4px] uppercase leading-normal items-center justify-center hover:opacity-60 transition-opacity duration-200 focus:outline-none whitespace-nowrap"
        type="button"
        aria-label="Subscribe to newsletter"
      >
        SUBSCRIBE
      </button>
      
      {/* Mobile Subscribe Button */}
      <button
        onClick={openNewsletterModal}
        className="md:hidden font-ibm-plex-sans-condensed font-normal text-[#e7131a] text-[12px] leading-[24px] tracking-[1px] uppercase underline decoration-solid underline-offset-[from-font] hover:opacity-60 transition-opacity duration-200"
        type="button"
        aria-label="Subscribe to newsletter"
      >
        SUBSCRIBE
      </button>
    </div>
  );
}